const DEFAULT_LANGUAGE = "en";
const SUPPORTED_LANGUAGES = ["en", "fr"];
const LANGUAGES = {
  en: {
    audioTracks: "Audio Tracks",
    captionsOn: "Turn Captions On",
    captionsOff: "Turn Captions Off",
    fullscreen: "Toggle fullscreen",
    gotolive: "Go to Live",
    live: "Live",
    pause: "Pause",
    play: "Play",
    stop: "Stop",
    share: "Share",
    unmute: "Unmute",
    mute: "Mute",
    close: "Close",
    skipForward: "Skip forward 15 seconds",
    skipBack: "Skip back 15 seconds",
    linkBtn: "Link",
    shareLinkLabel: "Link to video",
    shareTo: "Share to",
    shareEmail: "Share by email",
    email: "Email",
    embed: "Embed",
    copy: "Copy",
    copyLink: "Copy link",
    copyEmbed: "Copy embed code",
    buffered: "Buffered",
    seekBar: "Seek slider",
    volumeLevel: "Volume level",
    playThisVideo: "Play this video",
    closedCaptionsAvailable: "Closed-captions available",
    recommended: "Recommended for You",
    waitingForLiveStream: "Waiting for live stream",
    mediaError: "This stream is currently unavailable, it could be over.",
    ago: "ago",
    started: "Started",
    in: "In",
    now: "now",
    year: "year",
    month: "month",
    day: "day",
    hour: "hour",
    minute: "minute",
    second: "second",
    advertisement: "Advertisement",
    ad: "Ad",
    of: "of",
    off: "Off",
    adInProgress: "Playback will start after this advertisement",
    ctaBeforeLink: "Learn how to ",
    ctaLinkText: "customize closed captions",
    ctaAfterLink: " in your system settings.",
    closedCaptions: "Closed Captions",
    cancel: "Cancel",
    autoplay: "Autoplay",
    upNextIn: "Up next in",
    moreOptions: "More options",
    backToPreviousMenu: "Back to previous menu",
    playbackSpeed: "Playback Speed",
    slowest: "Slowest: 0.25x",
    slower: "Slower: 0.5x",
    slow: "Slow: 0.75x",
    normal: "Normal: 1x (Default)",
    slightlyFaster: "Slightly faster: 1.25x",
    fast: "Fast: 1.5x",
    faster: "Faster: 1.75x",
    fastest: "Fastest: 2x"
  },
  fr: {
    audioTracks: "Vidéodescriptions",
    captionsOn: "Activer les sous-titres codés",
    captionsOff: "Désactivés les sous-titres codés",
    fullscreen: "Mode plein écran",
    gotolive: "En Direct",
    live: "En Direct",
    pause: "Pause",
    play: "Écouter",
    stop: "Arrêter",
    share: "Partager",
    unmute: "Désactiver le son",
    mute: "Activer le son",
    close: "Fermer",
    skipForward: "Avancer de 15 secondes",
    skipBack: "Reculer de 15 secondes",
    linkBtn: "Lien",
    shareLinkLabel: "Le lien de la vidéo",
    shareTo: "Partager sur",
    shareEmail: "Partager par courriel",
    email: "Courriel",
    embed: "Intégrer",
    copy: "Copier",
    copyLink: "Copier le lien de la vidéo",
    copyEmbed: "Copier le code pour intégrer la vidéo",
    buffered: "Tamponnée",
    seekBar: "Barre de progression",
    volumeLevel: "Niveau de volume",
    playThisVideo: "Regarder la vidéo",
    closedCaptionsAvailable: "Sous-titres codés offerts",
    recommended: "Recommandé pour vous",
    waitingForLiveStream: "En attente de diffusion en direct",
    mediaError: "Erreur provenant du média",
    ago: "il y a",
    started: "Commencé",
    in: "En",
    now: "maintenant",
    year: "an",
    month: "mois",
    day: "jour",
    hour: "heure",
    minute: "minute",
    second: "seconde",
    advertisement: "Publicité",
    ad: "Publicité",
    of: "de",
    off: "Désactivé",
    adInProgress: "La lecture commencera après cette publicité",
    ctaBeforeLink: "Découvrez comment ",
    ctaLinkText: "personnaliser les sous-titres",
    ctaAfterLink: " dans les paramètres de votre système.",
    closedCaptions: "Sous-titres Codés",
    cancel: "Annuler",
    autoplay: "Lecture automatique",
    upNextIn: "À venir dans",
    moreOptions: "Plus d'options",
    backToPreviousMenu: "Revenir au menu précédent",
    playbackSpeed: "Vitesse de lecture",
    slowest: "Le plus lent : 0,25x",
    slower: "Plus lent : 0,5x",
    slow: "Lent : 0,75x",
    normal: "Normal : 1x (Par défaut)",
    slightlyFaster: "Légèrement plus rapide : 1,25x",
    fast: "Rapide : 1,5x",
    faster: "Plus rapide : 1,75x",
    fastest: "Le plus rapide: 2x"
  }
};
const determineLanguage = () => {
  if (typeof window === "undefined" || typeof window.navigator === "undefined") {
    return DEFAULT_LANGUAGE;
  }
  const browserLanguage = window.navigator.language;
  if (browserLanguage !== undefined && SUPPORTED_LANGUAGES.includes(browserLanguage.substring(0, 2))) {
    return browserLanguage.substring(0, 2);
  }
  const browserLanguages = window.navigator.languages;
  if (browserLanguages && browserLanguages.length > 0) {
    const lang = browserLanguages.find(language => SUPPORTED_LANGUAGES.includes(language.substring(0, 2)));
    if (lang) {
      return lang.substring(0, 2);
    }
  }
  return DEFAULT_LANGUAGE;
};
const init = () => {
  const lang = determineLanguage();
  const getLanguage = () => {
    return lang;
  };
  return {
    audioTracks: LANGUAGES[lang]["audioTracks"],
    captionsOn: LANGUAGES[lang]["captionsOn"],
    captionsOff: LANGUAGES[lang]["captionsOff"],
    fullscreen: LANGUAGES[lang]["fullscreen"],
    gotolive: LANGUAGES[lang]["gotolive"],
    live: LANGUAGES[lang]["live"],
    pause: LANGUAGES[lang]["pause"],
    play: LANGUAGES[lang]["play"],
    stop: LANGUAGES[lang]["stop"],
    share: LANGUAGES[lang]["share"],
    unmute: LANGUAGES[lang]["unmute"],
    mute: LANGUAGES[lang]["mute"],
    close: LANGUAGES[lang]["close"],
    skipForward: LANGUAGES[lang]["skipForward"],
    skipBack: LANGUAGES[lang]["skipBack"],
    linkBtn: LANGUAGES[lang]["linkBtn"],
    shareLinkLabel: LANGUAGES[lang]["shareLinkLabel"],
    shareTo: LANGUAGES[lang]["shareTo"],
    shareEmail: LANGUAGES[lang]["shareEmail"],
    email: LANGUAGES[lang]["email"],
    embed: LANGUAGES[lang]["embed"],
    copy: LANGUAGES[lang]["copy"],
    copyLink: LANGUAGES[lang]["copyLink"],
    copyEmbed: LANGUAGES[lang]["copyEmbed"],
    buffered: LANGUAGES[lang]["buffered"],
    seekBar: LANGUAGES[lang]["seekBar"],
    volumeLevel: LANGUAGES[lang]["volumeLevel"],
    playThisVideo: LANGUAGES[lang]["playThisVideo"],
    closedCaptionsAvailable: LANGUAGES[lang]["closedCaptionsAvailable"],
    recommended: LANGUAGES[lang]["recommended"],
    waitingForLiveStream: LANGUAGES[lang]["waitingForLiveStream"],
    mediaError: LANGUAGES[lang]["mediaError"],
    ago: LANGUAGES[lang]["ago"],
    started: LANGUAGES[lang]["started"],
    in: LANGUAGES[lang]["in"],
    now: LANGUAGES[lang]["now"],
    year: LANGUAGES[lang]["year"],
    month: LANGUAGES[lang]["month"],
    day: LANGUAGES[lang]["day"],
    hour: LANGUAGES[lang]["hour"],
    minute: LANGUAGES[lang]["minute"],
    second: LANGUAGES[lang]["second"],
    advertisement: LANGUAGES[lang]["advertisement"],
    ad: LANGUAGES[lang]["ad"],
    of: LANGUAGES[lang]["of"],
    off: LANGUAGES[lang]["off"],
    adInProgress: LANGUAGES[lang]["adInProgress"],
    ctaBeforeLink: LANGUAGES[lang]["ctaBeforeLink"],
    ctaLinkText: LANGUAGES[lang]["ctaLinkText"],
    ctaAfterLink: LANGUAGES[lang]["ctaAfterLink"],
    closedCaptions: LANGUAGES[lang]["closedCaptions"],
    cancel: LANGUAGES[lang]["cancel"],
    autoplay: LANGUAGES[lang]["autoplay"],
    upNextIn: LANGUAGES[lang]["upNextIn"],
    moreOptions: LANGUAGES[lang]["moreOptions"],
    backToPreviousMenu: LANGUAGES[lang]["backToPreviousMenu"],
    playbackSpeed: LANGUAGES[lang]["playbackSpeed"],
    slowest: LANGUAGES[lang]["slowest"],
    slower: LANGUAGES[lang]["slower"],
    slow: LANGUAGES[lang]["slow"],
    normal: LANGUAGES[lang]["normal"],
    slightlyFaster: LANGUAGES[lang]["slightlyFaster"],
    fast: LANGUAGES[lang]["fast"],
    faster: LANGUAGES[lang]["faster"],
    fastest: LANGUAGES[lang]["fastest"],
    getLanguage
  };
};
const LocaleSingleton = () => {
  let _instance;
  return () => {
    if (!_instance) {
      _instance = init();
    }
    return _instance;
  };
};
const Locale = LocaleSingleton();
export { Locale as L };